import keyBy from 'lodash/keyBy';

import {cohortsClient} from 'common/report/queries/app-api/cohorts-client';
import {
  SerializedCohort,
  SerializedInlineCohort,
} from 'common/widgets/cohorts-query-builder/models/types/serialized-cohort-types';

import {Store} from './store';

export interface CohortsMap {
  [cohortId: string]: SerializedCohort | SerializedInlineCohort;
}

export const cohortsStore = new Store<CohortsMap>({
  apiClient: cohortsClient,
  defaultValue: {},
  name: `cohorts`,
  transform: {
    index: (cohorts) => keyBy(cohorts, `id`),
    update: (updatedCohort) => ({k: updatedCohort.id, v: updatedCohort}),
  },
});
